var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-white",class:[_vm.activeClass],on:{"click":_vm.togglePanel}},[_c('Icon',{attrs:{"name":"icon-settings"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }